import React from 'react'
import { connect } from 'react-redux'
import { Button } from 'components/UIElements'
import 'styles/d3/drawer.scss'
import { drawerActions } from 'store/drawer'
import { closeIcon } from '../assets/assets'

const delay = 150

class Drawer extends React.Component {
  constructor(props) {
    super(props)
    this.state = { closing: false }
  }

  onCloseDrawer = func => {
    this.setState({ closing: true })
    setTimeout(() => {
      func()
      this.setState({ closing: false })
    }, delay)
  }

  render() {
    const {
      open,
      className,
      closeOnBackgroundClick,
      onCancel,
      closeDrawer,
      children,
      content
    } = this.props
    const { closing } = this.state
    const _className = `d3-drawer drawer-${open ? 'open' : 'closed'}${
      className ? ` ${className}` : ''
    }`
    return (
      <div
        className={_className}
        onClick={() =>
          this.onCloseDrawer(
            closeOnBackgroundClick ? onCancel || closeDrawer : null
          )
        }
      >
        <div
          onClick={e => e.stopPropagation()}
          className={`content${closing ? ' closing' : ''}`}
        >
          <Button
            className='close'
            onClick={() => this.onCloseDrawer(onCancel || closeDrawer)}
          >
            {closeIcon()}
          </Button>
          {children || content}
        </div>
      </div>
    )
  }
}

export default connect(
  null,
  drawerActions
)(Drawer)
